<img [src]="sourcePath()" [attr.width]="width()" [attr.height]="height()" [alt]="altText()" />
